import { render, staticRenderFns } from "./OperaGoodsWindow.vue?vue&type=template&id=05f4d673&scoped=true&"
import script from "./OperaGoodsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsWindow.vue?vue&type=style&index=0&id=05f4d673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4d673",
  null
  
)

export default component.exports